module.exports = __webpack_public_path__ + "img/icon3.24b39ee4.png";